import {Action} from '@reduxjs/toolkit';
import {ForkEffect, call, put, takeLatest} from 'redux-saga/effects';

import {logout} from '../userSlice';
import {removeAuthenticationToken, unregisterUser} from '../userApi';

function requestLogout(): Action<'user/requestLogout'> {
  return {
    type: 'user/requestLogout',
  };
}

function* requestLogoutSaga() {
  yield put(logout());
  yield call(removeAuthenticationToken);
  yield call(unregisterUser);
}

function* watchRequestLogout(): Generator<ForkEffect<void>, void, unknown> {
  yield takeLatest('user/requestLogout', requestLogoutSaga);
}

export {requestLogout};

export default watchRequestLogout;
